//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchFilterCam from '~/components/content/cam/filters/searchFilterCam';
import filtersListMobile from '~/components/content/cam/filters/filtersListMobile';
import { mapState } from 'vuex';

export default {
  name: 'mobileFilters',
  components: {
    searchFilterCam,
    filtersListMobile,
  },
  data() {
    return {
      isFiltersVisible: false,
    };
  },
  computed: {
    ...mapState({
      camFilter: ({ camStore: { camFilter } }) => camFilter,
    }),
    getFiltersCount() {
      let count = 0;

      for (const key in this.camFilter.activated) {
        if (this.camFilter.activated.hasOwnProperty(key)) {
          const value = this.camFilter.activated[key];

          if (value !== '' && value !== false) {
            count++;
          }
        }
      }

      return count;
    },
  },
};
